/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_P3_DInputs */

const en_mk_sec_pg_p3_d = /** @type {(inputs: Mk_Sec_Pg_P3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending, posting or paying always stops at the approval queue. That gate is enforced by the server, not requested in a text instruction.`)
};

const id_mk_sec_pg_p3_d = /** @type {(inputs: Mk_Sec_Pg_P3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengirim, memposting, atau membayar selalu berhenti di antrean approval. Batas ini ditegakkan server, bukan diminta lewat instruksi teks.`)
};

/**
* | output |
* | --- |
* | "Sending, posting or paying always stops at the approval queue. That gate is enforced by the server, not requested in a text instruction." |
*
* @param {Mk_Sec_Pg_P3_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_p3_d = /** @type {((inputs?: Mk_Sec_Pg_P3_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_P3_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_p3_d(inputs)
	return en_mk_sec_pg_p3_d(inputs)
});